import _ from "lodash";
import Vue from "vue";
export const EventBus = new Vue({
    data: {
        eventListeners: {}
    },
    methods: {}
});
